    <!-- 运维管理 -->
<template>
  <div class="gm-page pa-4">
    <PageTop :menus="['告警信息', '参数设置', '数据分析']" />
    <div class="mt-4 gm-card rounded-lg tab-bar">
      <v-tabs :model-value="tab" color="var(--color-primary)" @update:modelValue="handleTabChange">
        <v-tab v-for="item in visibleTabs" :key="item.value" :value="item.value"
          :class="{ 'vip-feature-tab': item.vip }">
          <span class="tab-label" :class="{ 'tab-label--vip': item.vip }">
            <span>{{ item.label }}</span>
            <span v-if="item.vip" class="vip-mark">VIP</span>
          </span>
        </v-tab>
      </v-tabs>
    </div>
    <div class="summary-router-host mt-4">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import PageTop from '@/components/PageTop/index.vue'
import { useRouter, useRoute } from 'vue-router'
import useUserStore from '@/store/modules/user'
import { hasAnyPermission } from '@/config/menuPermissionGroups'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const { permissions } = storeToRefs(userStore)
const tab = computed(() => route.path.split('/').pop() || 'overview')
const tabs = [
  { value: 'overview', label: '运维总览', perms: ['ops:overview:query'] },
  { value: 'stations', label: '电站管理', perms: ['ops:station:query'] },
  { value: 'alarm', label: '告警管理', perms: ['ops:alarm:query'] },
  { value: 'investors', label: '客户管理', perms: ['ops:customer:query'] },
  { value: 'ota', label: 'OTA升级', perms: ['ops:ota:query'] },
  { value: 'alarm-analysis', label: '告警分析', vip: true, perms: ['ops:alarmAnalysis:query'] },
]

function hasPerms(perms) {
  return hasAnyPermission(permissions.value, perms)
}

const visibleTabs = computed(() => tabs.filter(item => hasPerms(item.perms)))

watch(visibleTabs, (list) => {
  if (!list.length) return
  if (!list.some(item => item.value === tab.value)) {
    handleTabChange(list[0].value)
  }
}, { immediate: true, flush: 'post' })

function handleTabChange(path) {
  if (path === tab.value) return
  router.push({
    path: `/it-operations/multi/${path}`,
  })
}

</script>

<style scoped lang="scss">
.tab-bar {
  box-shadow: 0 2px 8px rgba(8, 40, 87, 0.05);

  :deep(.vip-feature-tab) {
    --vip-tab-color: var(--color-text, #1a2234);
  }

  :deep(.vip-feature-tab.v-tab--selected) {
    --vip-tab-color: var(--color-primary, #426cf9);
  }
}

.tab-label {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.tab-label--vip {
  gap: 2px;
  color: var(--vip-tab-color);
}

.vip-mark {
  position: relative;
  top: -6px;
  color: #c78618;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  background: linear-gradient(105deg, #b8750f 0%, #b8750f 42%, #fff2b8 50%, #d89620 58%, #b8750f 100%);
  background-size: 280% 100%;
  background-position: 100% center;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: vip-mark-glint 4s ease-in-out infinite;
}

@keyframes vip-mark-glint {

  0%,
  62% {
    background-position: 100% center;
    filter: drop-shadow(0 0 0 rgba(214, 151, 39, 0));
  }

  78% {
    filter: drop-shadow(0 0 3px rgba(224, 161, 43, 0.55));
  }

  100% {
    background-position: 0 center;
    filter: drop-shadow(0 0 0 rgba(214, 151, 39, 0));
  }
}

@media (prefers-reduced-motion: reduce) {
  .vip-mark {
    animation: none;
    background: none;
    -webkit-text-fill-color: currentColor;
  }
}

/* 占满 gm-page 剩余高度；子页（如电站管理）可内部滚动表格，总览等长内容仍在本区域整体滚动 */
.summary-router-host {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
</style>
